import * as React from 'react'
import { createContext, PropsWithChildren, ReactElement, useMemo, useState } from 'react'
import HammockFormDialog from '../v2/components/Dialog/HammockFormDialog'
import { TimeMutationDto, TimeOverviewDto } from '../config/registrationConfig'
import { BaseMutableOverviewDialogProps } from '../pages/BaseMutableOverview/BaseMutableOverview'
import TimeSuggestionMutationDialogBody, { TrackTimeSuggestionDto } from '../v2/components/Dialog/Registration/TimeSuggestionMutationDialogBody'
import TimeMutationDialogBody from '../v2/components/Dialog/Registration/TimeMutationDialogBody'

export type PopupContextType = {
    showTimeSuggestionDialog: boolean
    setShowTimeSuggestionDialog: (item: Partial<TrackTimeSuggestionDto>) => void
    cancelTimeSuggestionDialog: (id: string) => void
    showTimeTrackingDialog: boolean
    setShowTimeTrackingDialog: (item: Partial<TimeMutationDto>) => void
}

const PopupContext = createContext<PopupContextType>(null)

export function PopupProvider(props: PropsWithChildren): ReactElement {
    const [showTimeSuggestionDialog, setShowTimeSuggestionDialog] = useState<Partial<TrackTimeSuggestionDto>>(undefined)
    const [showTimeTrackingDialog, setShowTimeTrackingDialog] = useState<Partial<TimeMutationDto>>(undefined)

    const cancelTimeSuggestionDialog = useMemo(
        () => (id: string) => {
            //Only cancel the time suggestion when the ids match
            if (showTimeSuggestionDialog?.timeSuggestionId === id) {
                setShowTimeSuggestionDialog(undefined)
            }
        },
        [showTimeSuggestionDialog],
    )

    return (
        <PopupContext.Provider
            value={{
                showTimeSuggestionDialog: showTimeSuggestionDialog !== undefined,
                setShowTimeSuggestionDialog,
                cancelTimeSuggestionDialog,
                showTimeTrackingDialog: showTimeTrackingDialog !== undefined,
                setShowTimeTrackingDialog,
            }}
        >
            <>
                <div aria-label={'global-popups'}>
                    <HammockFormDialog<Partial<TrackTimeSuggestionDto>, BaseMutableOverviewDialogProps<TimeOverviewDto>>
                        open={showTimeSuggestionDialog !== undefined}
                        setOpen={open => setShowTimeSuggestionDialog(open ? showTimeSuggestionDialog : undefined)}
                        dialogFormProps={() => ({ initialValues: { ...showTimeSuggestionDialog }, onSubmit: () => {} })}
                        dialogFormBody={TimeSuggestionMutationDialogBody}
                        onDismiss={() => {
                            setShowTimeSuggestionDialog(undefined)
                        }}
                    />
                    <HammockFormDialog<Partial<TimeMutationDto>, BaseMutableOverviewDialogProps<TimeOverviewDto>>
                        open={showTimeTrackingDialog !== undefined}
                        setOpen={open => setShowTimeTrackingDialog(open ? showTimeTrackingDialog : undefined)}
                        dialogFormProps={() => ({ initialValues: { ...showTimeTrackingDialog }, onSubmit: () => {} })}
                        dialogFormBody={TimeMutationDialogBody}
                        onDismiss={() => {
                            setShowTimeTrackingDialog(undefined)
                        }}
                    />
                </div>
                {props.children}
            </>
        </PopupContext.Provider>
    )
}

export default PopupContext
